<template>
  <div class="home column__center__center">
    <section class="hello">
      <HelloWorld />
    </section>
    <section class="resume">
      <CodeResume />
    </section>
    <section class="contact">
      <Contact />
    </section>
  </div>
</template>

<script>
import HelloWorld from '@/components/HelloWorld.vue'
import CodeResume from '@/components/CodeResume.vue'
import Contact from '@/components/Contact.vue'

export default {
  name: 'HomeView',
  components: {
    HelloWorld,
    CodeResume,
    Contact,
  },
}
</script>

<style lang="scss" scoped>
.home {
  max-width: 800px;
}
</style>
